import { Component, Field } from '@contember/interface'

export const ConfigurationsPreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
